/**
 * StatsDropdown.jsx
 * ─────────────────────────────────────────────────────────────
 * IJ:       IJ-465 · Phase 5.5c · Knowledge Graph Stats dropdown
 * Date:     2026-09-02
 * Umbrella: IJ-076 · Refactor Programme 2026 · Phase 5
 * Owner:    E1
 *
 * Purpose:
 *   Presentational-only extract of the Knowledge Graph Stats dropdown
 *   render fragment from KnowledgeGraphPage.jsx. JSX is byte-verbatim.
 *   Zero behaviour change.
 *
 * Props:
 *   showStatsDropdown    · boolean · dropdown visibility
 *   setShowStatsDropdown · setter  · closes the dropdown on backdrop click
 *   stats                · object  · { documents, entities, relationships }
 */
export const StatsDropdown = ({ showStatsDropdown, setShowStatsDropdown, stats }) => {
  return (
    <>
      {/* Stats dropdown */}
      {showStatsDropdown && (
        <div className="fixed inset-0 z-40" onClick={() => setShowStatsDropdown(false)}>
          <div className="absolute right-6 top-20 w-72 bg-gray-900/95 border border-gray-600 rounded-lg shadow-2xl z-50" onClick={(e) => e.stopPropagation()}>
            <div className="p-4">
              <h3 className="text-base font-semibold text-white mb-4">Knowledge Graph Stats</h3>
              <div className="space-y-2">
                <div className="flex items-center justify-between"><span className="text-sm text-gray-300">Documents</span><span className="text-sm font-bold text-white">{stats.documents}</span></div>
                <div className="flex items-center justify-between"><span className="text-sm text-gray-300">Entities</span><span className="text-sm font-bold text-white">{stats.entities}</span></div>
                <div className="flex items-center justify-between"><span className="text-sm text-gray-300">Relationships</span><span className="text-sm font-bold text-white">{stats.relationships}</span></div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
